import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      green_300: { main: green300 } = {},
      green_400: { main: green400 } = {},
      dark_50: { main: dark50 } = {},
      blue_50: { main: blue50 } = {},
      dark_600: { main: dark600 } = {},
      dark_stroke: { main: darkStroke } = {},
      red_100: { main: red100 } = {},
      red_200: { main: red200 } = {}
    } = {}
  } = theme
  return {
    chipPlan: {
      padding: '0 !important',
      borderRadius: '4px',
      height: '16px',
      background: isDark ? dark600 : blue50,
      color: isDark ? dark50 : blue300,
      borderColor: isDark ? darkStroke : blue300
    },
    chipBase: {
      padding: '0 !important',
      fontSize: '.7rem',
      fontWeight: 'bold',
      '& span': {
        padding: '0 6px !important'
      }
    },
    chipActive: {
      padding: '0 !important',
      borderRadius: '4px',
      height: '16px',
      backgroundColor: green300,
      color: green400,
      borderColor: green400,
      '& span': {
        padding: '0 6px !important'
      }
    },
    chipInactive: {
      padding: '0 !important',
      borderRadius: '4px',
      height: '16px',
      backgroundColor: red200,
      color: red100,
      borderColor: red100,
      '& span': {
        padding: '0 6px !important'
      }
    },
    buttonImpersonate: {
      height: '18px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      fontWeight: 'bold',
      borderRadius: '4px',
      background: blue50,
      color: blue300,
      border: `1px solid ${blue300}`
    }
  }
})
